// @core/api/endpoints/task/list_scheduled_tasks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListScheduledTasksResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List scheduled tasks
 * Returns tasks that have a CalendarAspect (scheduled work) within the specified time range. Filterable by assignee for workforce planning views — see who is doing what and when across the team.
 */
export async function ListScheduledTasks(
  params?: PaginatedRequest & {
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListScheduledTasksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/scheduled`;
  const requestOptions = options;
  return client.get<ListScheduledTasksResponse>(requestPath, { ...requestOptions, params });
}
